import { useState } from "react";
import {
  defValueCondicoesPagamentor,
  IPesquisaCondicoesPagamento,
} from "../../screens/Configuracoes/Usuarios/DialogCriacaoEditUser/DialogCrudPerfil";
import { Dialog } from "@mui/material";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import MultipleChipsField from "../BaseInputs/MultipleChipsField";

export default function SelectCondicoesPagamentoCs9({
  value,
  onChange,
  required = false,
  error = false,
  extraParams,
}: SelectCondicoesPagamentoCs9Props) {
  const [openModal, setOpenModal] = useState(false);

  const handleClose = () => setOpenModal(false);

  return (
    <>
      <MultipleChipsField
        value={value}
        label="Condições de pagamento"
        formatChipLabel={(item) => `${item.id} - ${item.nome}`}
        onClick={() => setOpenModal(true)}
        error={!!error}
        helperText={error ? "Campo obrigatório" : ""}
      />

      {openModal && (
        <Dialog fullWidth maxWidth="sm" open={openModal} onClose={handleClose}>
          <DialogContentSelectGeneric
            {...{ handleClose, extraParams }}
            multiple
            title="Selecionar condições de pagamento"
            queryPath="pesquisar-condicoes-pagamento-cs9"
            getItemKey={(item) => item.id}
            getItemLabel={(item) => (item ? `${item.id} - ${item.nome}` : "")}
            defaultValue={value ? value : [defValueCondicoesPagamentor]}
            onChange={(value) => {
              onChange(value as IPesquisaCondicoesPagamento[]);
              handleClose();
            }}
          />
        </Dialog>
      )}
    </>
  );
}

interface SelectCondicoesPagamentoCs9Props {
  value: IPesquisaCondicoesPagamento[] | null;
  onChange: (arg: IPesquisaCondicoesPagamento[] | null) => void;
  required?: boolean;
  error?: boolean;
  extraParams?: { [key: string]: any };
}
